import * as React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const OutlineErrorIcon = (props) => {
    const { stroke = '#ff0f00', ...other } = props;
    return (
        <SvgIcon {...other}  viewBox="0 0 64 64" width="64" height="64" fontSize="xxxLarge">
          <path style={{ fill: 'none', stroke: stroke, strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2px'}}
                d="M129,403.667V417m0,13.333h.033M159,417a30,30,0,1,1-30-30A30,30,0,0,1,159,417Z"
                transform="translate(-98 -386)"/>
        </SvgIcon>
    );
};

export default OutlineErrorIcon;
